<template>
  <div class="home" ref="home">
    <div class="container1 row">
      <div class="upload_container" @dragover.prevent @drop.prevent v-bind:style="{ 'border-color': border_color }" v-show="!loaded">
        <div class="file-wrapper" @dragleave="fileDragOut" @dragover="fileDragIn" @drop="(e) => {handleFileInput(e, 'drop'); fileDragOut(e)}" v-bind:style="{ 'background-color': color, 'color': textColor}">
          <input id="fileInput" type="file" name="file-input" multiple="false" @change="(e) => {handleFileInput(e, 'input');}" > Click or drag image.
        </div>
        
      </div>
      <canvas class="canvas_preview" v-show="loaded"><img src="favicon.ico"/></canvas>
      <canvas class="canvas_image"><img src="favicon.ico"/></canvas>

      <div>
        <button  class="advancedButton" ref="advancedButton" @click="toggleAdvanced">Advanced Options</button>
        <OptionsMenu :filename="name" v-show="advancedOptions"></OptionsMenu>
      </div>
      <button class="generateButton" ref="generateButton" @click="generate" :disabled="!loaded">Generate</button>
    </div>
    <div class="container2 row">
      <button class="clearButton" ref="clearButton" @click="clearImage" >Clear image</button>
    </div>
  </div>
</template>

<script>
import OptionsMenu from '../components/optionsMenu';
import ModuleTest from '../wasm/NftMarkerCreator.min.js';
import EXIF from 'exif-js';

export default {
  name: 'Home',
  components: {
    OptionsMenu
  },
  data(){
    return{
      // Module: null,
      file: null,
      color: 'white',
      border_color: 'black',
      textColor: 'black',
      loaded: false,
      advancedOptions: false,
      name: null,
      nameWithExt: null,
      userFilename: null,
      globalObj:{
          dpi: 0,
          nc: 0,
          w: 0,
          h: 0,
          arr: []
      },
      argsMenu:[
        {
          evt: "zft",
          checked: false
        },
        {
          evt: "dpi",
          checked: false,
          input: null
        },
        {
          evt: "level",
          checked: false,
          input: null
        },
        {
          evt: "leveli",
          checked: false,
          input: null
        },
        {
          evt: "sd_thresh",
          checked: false,
          input: null
        },
        {
          evt: "max_thresh",
          checked: false,
          input: null
        },
        {
          evt: "min_thresh",
          checked: false,
          input: null
        },
        {
          evt: "feature_density",
          checked: false,
          input: null
        },
      ]
    }
  },
  methods: {
    clearImage(){
      var canvasEl = document.querySelector('.canvas_preview');
      var ctx = canvasEl.getContext('2d');
      var canvasHidden = document.querySelector('.canvas_image');
      var ctxHide = canvasHidden.getContext('2d');

      ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
      ctxHide.clearRect(0, 0, canvasHidden.width, canvasHidden.height);

      document.querySelector("#fileInput").value = "";
      this.loaded = false;
    },
    handleFileInput(e, type) {
      if(type === 'drop'){
        this.file = e.dataTransfer.files[0];
      }else{
        this.file = e.target.files[0];
      }
      console.log("Image uploaded: " + this.file.name);

      this.nameWithExt = this.file.name;

      this.name = this.nameWithExt.substr(0, this.nameWithExt.lastIndexOf('.'));

      let extJpg = this.nameWithExt.substr(this.nameWithExt.lastIndexOf('.'));

      // let confidenceEl = document.getElementById("confidenceLevel");
      // let childEls = confidenceEl.getElementsByClassName("confidenceEl");
      // for(let i = 0; i < childEls.length; i++){
      //     childEls[i].src = "./icons/star2.svg";
      // }
      this.drawnOnCanvas(this.file);

      if (extJpg == '.jpg' || extJpg == '.jpeg' || extJpg == '.JPG' || extJpg == '.JPEG') {
          this.useJpeg(this.file);
      } else if (extJpg == '.png' || extJpg == '.PNG') {
          this.globalObj.dpi = 72;
      } else {
          console.log("Invalid image format!");
      }

      this.loaded = !this.loaded;
    },
    fileDragIn(){
      this.color="#8dd5b4";
      this.border_color = "#42b983";
      this.textColor = "white"
    },
    fileDragOut(){
      this.color="white";
      this.border_color = "black"
      this.textColor = 'black';
    },
    drawnOnCanvas(file){
        var reader = new FileReader();
        var _this = this;
        reader.onload = function (event) {
          var img = new Image();
          img.onload = function () {
              var canvasEl = document.querySelector('.canvas_preview');
              var ctx = canvasEl.getContext('2d');
              var canvasHidden = document.querySelector('.canvas_image');
              var ctxHide = canvasHidden.getContext('2d');
              canvasEl.width = canvasEl.clientWidth;
              canvasEl.height = canvasEl.clientHeight;

              canvasHidden.width = img.width;
              canvasHidden.height = img.height;

              _this.globalObj.w = img.width;
              _this.globalObj.h = img.height;

              ctxHide.drawImage(img, 0, 0);

              ctx.drawImage(img, 0, 0, img.width, img.height,     // source rectangle
                  0, 0, canvasEl.width, canvasEl.height); // destination rectangle

              var imgData = ctxHide.getImageData(0, 0, canvasHidden.width, canvasHidden.height);

              let newArr = [];

              let verifyColorSpace = _this.detectColorSpace(imgData.data);

              if (verifyColorSpace == 1) {
                  for (let j = 0; j < imgData.data.length; j += 4) {
                      newArr.push(imgData.data[j]);
                  }
              } else if (verifyColorSpace == 3) {
                  for (let j = 0; j < imgData.data.length; j += 4) {
                      newArr.push(imgData.data[j]);
                      newArr.push(imgData.data[j + 1]);
                      newArr.push(imgData.data[j + 2]);
                  }
              }

              _this.globalObj.nc = verifyColorSpace;

              let uint = new Uint8Array(newArr);

              _this.globalObj.arr = uint;

              // let confidence = _this.calculateQuality();
              // let confidenceEl = document.getElementById("confidenceLevel");
              // let childEls = confidenceEl.getElementsByClassName("confidenceEl");
              // for(let i = 0; i < parseInt(confidence.l); i++){
              //     childEls[i].src = "./icons/star.svg";
              // }
          }
          img.src = event.target.result;
      }
      reader.readAsDataURL(file);
    },
    useJpeg(file) {
      let _this = this;
      EXIF.getData(file, function () {
        var dpi1 = parseFloat(EXIF.getTag(this, "XResolution"));
        if (isNaN(dpi1) || dpi1 == null) {
          _this.globalObj.dpi = 72
        } else {
          _this.globalObj.dpi = dpi1;
        }

        var nc1 = EXIF.getTag(this, "ComponentsConfiguration")

        if (isNaN(nc1) || nc1 == null) {
            var nc2 = parseFloat(EXIF.getTag(this, "SamplesPerPixel"));
            if (isNaN(nc2) || nc2 == null) {
                // openModal();
            } else {
              _this.globalObj.nc = nc2;
            }
        } else {
          _this.globalObj.nc = nc1;
        }

      });
    },
    buf2hex(buffer) {
    return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('');
    },
    generate(){
      this.$refs["generateButton"].disabled = true;

      this.$refs["home"].style.opacity = "0.35";
      this.$refs["advancedButton"].disabled = true;
      this.$refs["clearButton"].disabled = true;

      let cmdArr = [0, this.name];
      for(let index in this.argsMenu){
        if(this.argsMenu[index].checked){
          let cmd = "";
          if(this.argsMenu[index].input != null){
            cmd = "-" + this.argsMenu[index].evt + "=" + this.argsMenu[index].input;
          }else{
            cmd = "-" + this.argsMenu[index].evt;
          }

          if(this.argsMenu[index].evt != "zft"){
            cmdArr.push(cmd);
          }
        }
      }
      let paramStr = cmdArr.join(' ');
      console.log(paramStr);

      setTimeout(() => {
        let StrBuffer = this.$NFTmodule._malloc(paramStr.length + 1);
        this.$NFTmodule.writeStringToMemory(paramStr, StrBuffer);
        
        let heapSpace = this.$NFTmodule._malloc(this.globalObj.arr.length * this.globalObj.arr.BYTES_PER_ELEMENT); // 1
        this.$NFTmodule.HEAPU8.set(this.globalObj.arr, heapSpace); // 2

        this.$NFTmodule._createImageSet(heapSpace, this.globalObj.dpi, this.globalObj.w, this.globalObj.h, this.globalObj.nc, StrBuffer);

        this.$NFTmodule._free(heapSpace);
        this.$NFTmodule._free(StrBuffer);
        
        this.createMarkerFiles();
      }, 500);
    },
    createMarkerFiles() {
      let mime = "application/octet-stream";

      let filenameIset = "tempFilename.iset";
      let filenameFset = "tempFilename.fset";
      let filenameFset3 = "tempFilename.fset3";

      let ext = ".iset";
      let ext2 = ".fset";
      let ext3 = ".fset3";
      let ext4 = ".zft";

      let content = this.$NFTmodule.FS.readFile(filenameIset);
      let contentFset = this.$NFTmodule.FS.readFile(filenameFset);
      let contentFset3 = this.$NFTmodule.FS.readFile(filenameFset3);

      let newFilename = this.name;

      if(this.userFilename != null){
        newFilename = this.userFilename;
      }

      if(this.argsMenu[0].checked){

        let iset = this.buf2hex(content.buffer);
        let fset = this.buf2hex(contentFset.buffer);
        let fset3 = this.buf2hex(contentFset3.buffer);

        let obj = {
            iset: iset,
            fset: fset,
            fset3: fset3
        }

        let strObj = JSON.stringify(obj);

        let StrBufferZip = this.$NFTmodule._malloc(strObj.length + 1);
        this.$NFTmodule.writeStringToMemory(strObj, StrBufferZip);
        
        this.$NFTmodule._compressZip(StrBufferZip, strObj.length);
        
        let contentBin = this.$NFTmodule.FS.readFile("tempBinFile.bin");

        this.$NFTmodule._free(StrBufferZip);

        var aZft = document.createElement('a');
        aZft.download = newFilename + ext4;
        aZft.href = URL.createObjectURL(new Blob([contentBin], { type: mime }));
        aZft.style.display = 'none';

        document.body.appendChild(aZft);
        aZft.click();
      }else{
        var a = document.createElement('a');
        a.download = newFilename + ext;
        a.href = URL.createObjectURL(new Blob([content], { type: mime }));
        a.style.display = 'none';

        var b = document.createElement('a');
        b.download = newFilename + ext2;
        b.href = URL.createObjectURL(new Blob([contentFset], { type: mime }));
        b.style.display = 'none';

        var c = document.createElement('a');
        c.download = newFilename + ext3;
        c.href = URL.createObjectURL(new Blob([contentFset3], { type: mime }));
        c.style.display = 'none';

        document.body.appendChild(a);
        a.click();

        document.body.appendChild(b);
        b.click();

        document.body.appendChild(c);
        c.click();
      }

      this.$refs["home"].style.opacity = "1";
      this.$refs["advancedButton"].disabled = false;
      this.$refs["clearButton"].disabled = false;
    },
    detectColorSpace(arr) {
      let target = parseInt(arr.length / 4);

      let counter = 0;

      for (let j = 0; j < arr.length; j += 4) {
          let r = arr[j];
          let g = arr[j + 1];
          let b = arr[j + 2];

          if (r == g && r == b) {
              counter++;
          }
      }

      if (target == counter) {
          return 1;
      } else {
          return 3;
      }
    },
    argsMenuUpdate(e){
      for(let index in this.argsMenu){
        if(this.argsMenu[index].evt == e.evt){
          this.argsMenu[index].checked = e.checked;
          this.argsMenu[index].input = e.input;
        }
      }
    },
    updateFilename(e){
      this.userFilename = e;
    },
    toggleAdvanced(){
      this.advancedOptions = !this.advancedOptions;
    }
  },
  beforeCreate(){
    if (this.$NFTmodule === null) {
      new ModuleTest().then(myModule => {
        this.$NFTmodule = myModule;
      });
    }

  },
  mounted(){
    this.$root.$on("argsMenu", this.argsMenuUpdate)
    this.$root.$on("changeName", this.updateFilename)
  }
}
</script>

<style scoped>
.home{
  display: flex;
  flex-direction: column;
  align-items: center;
}
/* SVG */
.generatingAnim{
  position: fixed;
  top: 30vh;
  width: 15vw;
  height: 15vw;
}
/* ROWS */
.row{
  display: flex;
  flex-direction: row;
  align-items: center;
}
/* UPLOAD CONTAINER */
.upload_container{
  border-style: dashed;
  border-radius: 5px;
  font-size: 2em;
}
.file-wrapper {
  text-align: center;
  width: 350px;
  height: 350px;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  overflow: hidden;
}
.file-wrapper input {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    opacity: 0.0;
    filter: alpha(opacity=0);
    font-size: 300px;
    height: 100%;
}
/* CANVAS */
.canvas_preview{
  width: 350px;
  height: 350px;
  border-style: dashed;
  border-radius: 5px;
}
.canvas_image{
  display: none;
}

/* BUTTONS */
.clearButton{
  position: relative;
  top: 10px;
  left: -300px;
  font-weight: bold;
  padding: 10px;
  color: red;
  background-color: transparent;
  border-style: solid;
  border-color: red;
  border-radius: 10px;
}
.clearButton:hover{
  background-color: #e57e7e;
  cursor: pointer;
}
.clearButton:active, .clearButton:focus {
  outline: 0;
  /* border: none; */
  -moz-outline-style: none;
}
.clearButton:disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.4;
}
.generateButton{
  width: 200px;
  height: 350px;
  font-weight: bold;
  color: #42b983;
  background-color: transparent;
  border-style: dashed;
  border-color: #42b983;
  border-radius: 10px;
  font-size: 25px;
}
.generateButton:hover{
  background-color: #8dd5b4;
  cursor: pointer;
  color: white;
}
.generateButton:active, .generateButton:focus {
  outline: 0;
  /* border: none; */
  -moz-outline-style: none; 
}
.generateButton:disabled {
  border-color: red;
  color: red;
  pointer-events: none;
  cursor: default;
}
.advancedButton{
  font-weight: bold;
  padding: 10px;
  color: black;
  background-color: transparent;
  border-style: solid;
  border-color: black;
  border-radius: 10px;
  margin: 10px;
}
.advancedButton:hover{
  background-color: gray;
  cursor: pointer;
}
.advancedButton:active, .advancedButton:focus {
  outline: 0;
  /* border: none; */
  -moz-outline-style: none;
}
.advancedButton:disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.4;
}
</style>
